class ProdutoFilter {
    static get $inject() {
        return ['$scope', 'Empresas']
    }

    constructor(scope, Empresas) {
        this.apply = (fn) => scope.$apply(fn)
        this.watch = (...args) => scope.$watch(...args)
        this.emit = (event, message) => scope.$emit(event, message)

        this.Empresas = Empresas
        this.filter = { ativo: true, hasReclassificacao: {} }

        this.problemas = [
            { key: "NCM_DIVERGENTE", descricao: "NCM divergente" },
            { key: "CEST_DIVERGENTE", descricao: "CEST divergente" },
            { key: "EX_TIPI_DIVERGENTE", descricao: "EX TIPI divergente" },
            { key: "INVALID_CODIGO_BARRAS", descricao: "Códigos de barras com possível inconsistência" },
            { key: "MISSING_CODIGO_BARRAS", descricao: "Código de barras não informado" }
        ]
    }

    async $onInit() {
        this.setupWatchers()

        this.ngModelCtrl.$render = () => {
            if (this.ngModelCtrl.$viewValue) {
                this.filter = this.ngModelCtrl.$viewValue
            }
        }

        await this.loadData()
    }

    loadData() {
        return this.Empresas
            .listFiliais(this.empresaId)
            .then(filiais => {
                filiais = filiais.filter(filial => {
                    return filial.ferramentasDisponiveis.includes("gestao-integrada-itens")
                })

                this.filiais = filiais

            })
            .then(() => this.apply())
    }

    setupWatchers() {
        this.watch(() => this.filter, () => this.submit(), true)
        this.watch(() => this.filial, newValue => {
            if (newValue) {
                this.updateFilter()
            }
        })
    }

    submit() {
        if (this.form && this.form.$valid) {
            if (this.filial) {
                this.updateFilter()
            }
        } else {
            this.ngModelCtrl.$setViewValue(null)
        }
    }

    updateFilter() {
        const {
            hasReclassificacao: { problemas, ...hasReclassificacao },
            ...filter
        } = angular.copy(this.filter)

        cbk.deleteEmptyKeys(filter)

        if (this.isTodosProblemas) {
            filter.hasReclassificacao = {
                ...hasReclassificacao,
                hasAllProblemas: problemas
            }
        } else {
            filter.hasReclassificacao = {
                ...hasReclassificacao,
                hasAnyProblemas: problemas
            }
        }

        if (!angular.equals(filter.descricao, undefined)) {
            filter.descricao = filter.descricao.replace(/ {1,}/ig, '+')
        }

        filter.etiquetasIds = filter.etiquetas && filter.etiquetas.length
            ? filter.etiquetas.map(e => e.id)
            : undefined

        delete filter.etiquetas

        filter.order = filter.descricao
            ? { sortField: 'RELEVANCIA', sortOrder: 'DESC' }
            : { sortField: 'UPDATED_AT', sortOrder: 'DESC' }

        this.ngModelCtrl.$setViewValue({ ...filter, filialId: this.filial.id })
    }

    toggleIsTodosProblemas() {
        this.isTodosProblemas = !this.isTodosProblemas

        this.submit()
    }
}

angular.module("eficienciaFiscalModule")
    .component("produtoFilter", {
        controller: ProdutoFilter,
        require: {
            ngModelCtrl: 'ngModel'
        },
        bindings: {
            empresaId: '<',
            onChange: '&'
        },
        template: `
            <form class="fade-animation" novalidate name="$ctrl.form" ng-submit="$ctrl.submit()">
                <div class="row">
                    <div class="form-group col-xs-12">
                        <label>Filial</label>
                        <ef-filial-selector
                            empresa-id="$ctrl.empresaId"
                            empresas="$ctrl.filiais"
                            name="filial"
                            ng-model="$ctrl.filial">
                        </ef-filial-selector>
                    </div>
                    <div class="form-group col-sm-3">
                        <label>
                            Código
                            <i class="fa fa-trash-o text-danger cursor-pointer" 
                               ng-click="$ctrl.filter.codigo = undefined"
                               ng-if="$ctrl.filter.codigo"></i>
                        </label>
                        <input type="text" class="form-control" ng-model="$ctrl.filter.codigo" ng-model-options="{ debounce: 500 }">
                    </div>
                    <div class="form-group col-sm-3">
                        <label>
                            Código de barras
                            <i class="fa fa-trash-o text-danger cursor-pointer" 
                               ng-click="$ctrl.filter.codigoBarras = undefined"
                               ng-if="$ctrl.filter.codigoBarras"></i>
                        </label>
                        <input type="text" class="form-control" ng-model="$ctrl.filter.codigoBarras" ng-model-options="{ debounce: 500 }">
                    </div>
                    <div class="form-group col-sm-6">
                        <label>
                            Descrição
                            <i class="fa fa-trash-o text-danger cursor-pointer" 
                               ng-click="$ctrl.filter.descricao = undefined"
                               ng-if="$ctrl.filter.descricao"></i>
                        </label>
                        <input type="text" class="form-control" ng-model="$ctrl.filter.descricao" ng-model-options="{ debounce: 500 }">
                    </div>
                    <div class="form-group col-sm-2">
                        <label>
                            NCM
                            <i class="fa fa-trash-o text-danger cursor-pointer" 
                               ng-click="$ctrl.filter.ncm = undefined"
                               ng-if="$ctrl.filter.ncm"></i>
                        </label>
                        <input type="text" class="form-control" ui-mask="9999.99.99"
                            ng-model="$ctrl.filter.ncm" ng-model-options="{ debounce: 500 }">
                    </div>
                    <div class="form-group col-sm-2 col-md-2">
                        <label>
                            EX TIPI
                            <i class="fa fa-trash-o text-danger cursor-pointer" 
                               ng-click="$ctrl.filter.exTipi = undefined"
                               ng-if="$ctrl.filter.exTipi"></i>
                        </label>
                        <input type="text" class="form-control" ui-mask="999"
                            ng-model="$ctrl.filter.exTipi" ng-model-options="{ debounce: 500 }">
                    </div>
                    <div class="form-group col-sm-2 col-md-2">
                        <label>
                            CEST
                            <i class="fa fa-trash-o text-danger cursor-pointer" 
                               ng-click="$ctrl.filter.cest = undefined"
                               ng-if="$ctrl.filter.cest"></i>
                        </label>
                        <input type="text" class="form-control" ui-mask="99.999.99"
                            ng-model="$ctrl.filter.cest" ng-model-options="{ debounce: 500 }">
                    </div>
                    <div class="form-group col-sm-2">
                        <label>
                            Status
                            <i class="fa fa-trash-o text-danger cursor-pointer" 
                               ng-click="$ctrl.filter.ativo = undefined"
                               ng-if="$ctrl.filter.ativo != undefined"></i>
                        </label>
                        <select class="form-control" ng-model="$ctrl.filter.ativo">
                            <option ng-value="true">Ativo</option>
                            <option ng-value="false">Inativo</option>
                        </select>
                    </div>
                    <div class="form-group col-sm-4">
                        <label>
                            Etiquetas
                            <i 
                                class="fa fa-trash-o text-danger cursor-pointer" 
                                ng-click="$ctrl.filter.etiquetas = []"
                                ng-if="$ctrl.filter.etiquetas.length">
                            </i>
                        </label>
                        <ef-etiquetas-selector 
                            ng-model="$ctrl.filter.etiquetas" 
                            empresa-id="$ctrl.empresaId"
                            position="end">
                        </ef-etiquetas-selector>
                    </div>
                    <div class="form-group col-sm-3 col-md-3">
                        <button type="submit" class="btn btn-primary btn-block">
                            <i class=" fa fa-refresh"></i> Atualizar
                        </button>
                    </div>
                </div>
            </form>
        `
    })
